var render = function render(){
  var _vm$contract;
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('dashboard-layout', {
    attrs: {
      "fullHeight": ""
    }
  }, [_c('template', {
    slot: "title"
  }, [_c('v-row', {
    attrs: {
      "no-gutters": "",
      "align": "center"
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "auto"
    }
  }, [_c('h3', {
    staticClass: "tit grey-c--text"
  }, [_vm._v("근무계약서 회신내역")])]), _c('v-col', {
    attrs: {
      "cols": "auto"
    }
  }, [_c('span', {
    staticClass: "tit__line"
  })]), _c('v-col', {
    attrs: {
      "cols": "auto"
    }
  }, [_c('h3', {
    staticClass: "tit"
  }, [_vm._v(_vm._s((_vm$contract = _vm.contract) === null || _vm$contract === void 0 ? void 0 : _vm$contract.subject))])])], 1)], 1), _c('template', {
    slot: "contents"
  }, [_c('v-row', {
    staticClass: "mb-n4 mb-md-12",
    staticStyle: {
      "flex": "0 0 auto"
    },
    attrs: {
      "align-md": "center"
    }
  }, [_c('v-col', {
    staticClass: "mb-10 mb-md-0",
    attrs: {
      "cols": "12"
    }
  }, [_c('v-badge', {
    staticClass: "v-badge--btn",
    attrs: {
      "floating": "",
      "dot": ""
    }
  }, [_c('v-btn', {
    attrs: {
      "text": ""
    },
    on: {
      "click": function ($event) {
        return _vm.$router.go(-1);
      }
    }
  }, [_c('i', {
    staticClass: "icon icon-left-arrow mr-4 mr-lg-8"
  }), _c('h4', {
    staticClass: "tit--sm line-height-1"
  }, [_vm._v("상세보기")])])], 1)], 1), _c('v-col', {
    staticClass: "mb-12 mb-lg-0",
    attrs: {
      "cols": "12"
    }
  }, [_c('v-row', {
    staticClass: "ma-n8"
  }, [_c('v-col', {
    staticClass: "pa-8",
    attrs: {
      "cols": "12",
      "lg": "6"
    }
  }, [_c('v-row', {
    staticClass: "ma-n8"
  }, [_c('v-col', {
    staticClass: "pa-8",
    attrs: {
      "cols": "12"
    }
  }, [_c('employment-contract-view-info', {
    model: {
      value: _vm.contract,
      callback: function ($$v) {
        _vm.contract = $$v;
      },
      expression: "contract"
    }
  })], 1), _c('v-col', {
    staticClass: "pa-8",
    attrs: {
      "cols": "12"
    }
  }, [_c('employment-contract-view-user', {
    model: {
      value: _vm.contract,
      callback: function ($$v) {
        _vm.contract = $$v;
      },
      expression: "contract"
    }
  })], 1)], 1)], 1), _vm.contract.isSigned ? _c('v-col', {
    staticClass: "pa-8",
    attrs: {
      "cols": "12",
      "lg": "6"
    }
  }, [_c('employment-contract-view-logs', {
    model: {
      value: _vm.contract,
      callback: function ($$v) {
        _vm.contract = $$v;
      },
      expression: "contract"
    }
  })], 1) : _vm._e()], 1)], 1)], 1), _c('client-loader', _vm._b({}, 'client-loader', {
    loading: _vm.loading
  }, false))], 1)], 2);

}
var staticRenderFns = []

export { render, staticRenderFns }